import * as React from "react";
import "./Teachers.sass"
import SimpleGrid from "../../../_containers/grid/SimpleGrid";
import ImageItemGrid from "../../../_components/common/grid/ImageItemGrid";

import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getAllCommonTeachers} from "../../../_actions/commonService";
import {ADDRESS} from "../../../_api/client";
import Spinner from "./Spinner";
import {IDLE, LOADING} from "../../../common/statuses";

export default function Teachers() {

    const {data, status} = useSelector(state => state.common.teachers);
    const dispatch = useDispatch();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getAllCommonTeachers())
        }
        document.title = 'КьюАй - Методисты';
    }, [status, dispatch])

    if (status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    return (

        <div className="teachers-wrapper">
            <div className="teachers-context">
                <SimpleGrid>
                    {
                        data && data.map(item =>
                            <ImageItemGrid key={`image-item-grid-${item.id}`}
                                           imgStyle={{objectPosition: 'top'}}
                                           image={`${ADDRESS}/avatar/${item.img}`}
                                           title={`${item.lastName} ${item.firstName}`}
                                           link={`${item.id}`}/>)
                    }
                </SimpleGrid>
            </div>
        </div>
    )
}